export const PRIMENG_PT_BR = {

// Botões gerais
accept: "Sim",
reject: "Não",
choose: "Escolher",
upload: "Enviar",
cancel: "Cancelar",
clear: "Limpar",
today: "Hoje",

// Status comuns
pending: "Pendente",
completed: "Concluído",

// Datas
firstDayOfWeek: 1,

dayNames: [
"domingo","segunda-feira","terça-feira",
"quarta-feira","quinta-feira","sexta-feira","sábado"
],

dayNamesShort: [
"dom","seg","ter","qua","qui","sex","sab"
],

dayNamesMin: [
"D","S","T","Q","Q","S","S"
],

monthNames: [
"janeiro","fevereiro","março","abril","maio","junho",
"julho","agosto","setembro","outubro","novembro","dezembro"
],

monthNamesShort: [
"jan","fev","mar","abr","mai","jun",
"jul","ago","set","out","nov","dez"
],

// Tabela / filtros
startsWith: "Começa com",
contains: "Contém",
notContains: "Não contém",
endsWith: "Termina com",
equals: "Igual",
notEquals: "Diferente",
noFilter: "Sem filtro",
filter: "Filtrar",

lt: "Menor que",
lte: "Menor ou igual",
gt: "Maior que",
gte: "Maior ou igual",

dateIs: "Data é",
dateIsNot: "Data não é",
dateBefore: "Data antes de",
dateAfter: "Data depois de",

// Paginator
emptyMessage: "Nenhum registro encontrado",
emptyFilterMessage: "Nenhum resultado encontrado",

// FileUpload
fileChosenMessage: "Arquivo selecionado",
uploadMessage: "Upload realizado",

// ARIA (acessibilidade)
aria: {
trueLabel: "Verdadeiro",
falseLabel: "Falso",
nullLabel: "Não selecionado",
star: "1 estrela",
stars: "{star} estrelas",
selectAll: "Selecionar todos",
unselectAll: "Desmarcar todos",
close: "Fechar",
previous: "Anterior",
next: "Próximo",
navigation: "Navegação",
scrollTop: "Voltar ao topo"
}
};